module.exports = __webpack_public_path__ + "static/media/course-schedule.03b66480.svg";